// extracted by mini-css-extract-plugin
module.exports = {"list":"what-it-means-to-you_list__3GSWV"};